// Logique PURE du wizard de création de commande — testable sans rendu React.
//
// C'est ici que vit le correctif du bloquant « cliente existante → nouvelle
// cliente » (revue propriétaire du 21/07) : l'étape cliente n'est valide que si
// une cliente EST sélectionnée avec adresse + téléphone + boutique, ET que
// l'onglet « Nouvelle cliente » n'est PAS ouvert. Sans le garde-fou `!showNew`,
// on pouvait masquer la carte de l'ancienne cliente (via showNew) tout en gardant
// son `idClient`/ses contacts, et avancer — donc créer la commande pour ELLE.

// L'étape cliente est-elle complète et cohérente ?
export function customerStepValid({ showNew, idClient, idAdresse, idTelephone, idShop } = {}) {
  return Boolean(!showNew && idClient && idAdresse && idTelephone && idShop);
}

// Raison lisible du blocage (à afficher sous un CTA désactivé). Ordre = celui du
// parcours ; la boutique est explicitement exigée (règle UX du propriétaire).
export function customerStepReason({ showNew, idClient, idAdresse, idTelephone, idShop } = {}) {
  if (showNew) return 'Crée d’abord la nouvelle cliente (bouton « Créer la cliente »).';
  if (!idClient) return 'Sélectionne une cliente.';
  if (!idAdresse) return 'Choisis une adresse de livraison.';
  if (!idTelephone) return 'Choisis un téléphone.';
  if (!idShop) return 'Choisis la boutique concernée.';
  return '';
}

// Nombre réel de PAIRES au panier (somme des quantités), et non le nombre de
// lignes distinctes — sinon « 3 paires d'un même modèle » affichait « (1) ».
export function totalPaires(lignes) {
  return (lignes || []).reduce((s, l) => s + (Number(l.quantite) || 0), 0);
}
